import { Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { RouterStateSerializer } from '@ngrx/router-store';

import type { RouterStateUrl } from '@app/store/reducers';

@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  public serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route: ActivatedRouteSnapshot = routerState.root;
    let params: Record<string, any> = {};
    let data: Record<string, any> = {};

    while (route.firstChild) {
      route = route.firstChild;
      params = { ...params, ...route.params };
      data = { ...data, ...(route.data || {}) };
    }

    const {
      url,
      root: { queryParams },
    } = routerState;

    return { url, params, queryParams, data };
  }
}
